<!-- SelectAndOrderBy.vue -->
<script lang="ts" setup>
    import * as _ from 'lodash'
    import { computed } from 'vue';

    export interface IItem{
        name: string,
        selected?: boolean,
        data: any
    }

    const props = defineProps<{ 
        items: IItem[] 
    }>();

    const emit = defineEmits(["update:items", "changedSelection"]);

    const sortedItems = computed(() => {
        return props.items;
    });

    const nameNameCharacters = computed(()=>{
        return _.max(props.items.map(o => o.name.length)) ?? 0;
    });

    function UpdateItemOrder(_item: IItem, oldOrder:number, newOrder: number)
    {
        if (newOrder < 0)
            return;
        if (newOrder > props.items.length-1)
            return;
        
        let items = props.items;
        const thisItem = items.splice(oldOrder, 1);
        items.splice(newOrder, 0, thisItem[0]);

        emit("update:items", items);
    }

</script>

<template>
    <div v-for="(item, index) in sortedItems" class="mb-1">
        <div style="display:inline-block" :style="{width: (nameNameCharacters * 3/4) +'em'}">
            <input type="checkbox" v-model="item.selected" @change="emit('changedSelection')" />
            {{item.name}}
        </div>
        <button class="btn btn-primary btn-sm me-1" title="Move First" @click="UpdateItemOrder(item, index, 0)">
            <em class="fa-solid fa-angles-up"></em>
        </button>
        
        <button class="btn btn-primary btn-sm me-1" title="Move Prior" @click="UpdateItemOrder(item, index, index-1)">
            <em class="fa-solid fa-angle-up"></em>
        </button>

        <button class="btn btn-primary btn-sm me-1" title="Move Next" @click="UpdateItemOrder(item, index, index+1)">
            <em class="fa-solid fa-angle-down"></em>
        </button>

        <button class="btn btn-primary btn-sm me-1" title="Move Last" @click="UpdateItemOrder(item, index, props.items.length-1)">
            <em class="fa-solid fa-angles-down"></em>
        </button>
    </div>

</template>